import axios from 'axios';
import VoilaConfig from '../config';
import { openModal } from './ModalLoginActions';

export const ADD_TO_FAVORITES = 'ADD_TO_FAVORITES';
export const REMOVE_FROM_FAVORITES = 'REMOVE_TO_FAVORITES';
export const FETCH_FAVORITES = 'FETCH_FAVORITES';
export const RECEIVE_FAVORITES = 'RECEIVE_FAVORITES';
export const FETCH_FAVORITES_OTHER = 'FETCH_FAVORITES_OTHER';
export const RECEIVE_FAVORITES_OTHER = 'RECEIVE_FAVORITES_OTHER';

const FAVORITES_API_URL = `${VoilaConfig.API_URL}/citizen/account/favorites`;

export function addToFavorite(pProduct) {
  return (dispatch, getState) => {
    let { user } = getState();
    let pid=user.data.user_id

    if (user.authenticated) {
      return axios
        .post(FAVORITES_API_URL, { product_id: pProduct.id, user_id: pid }, {
          headers: {
            'Authorization': `Bearer ${user.data.token}`
          }
        })
        .then((res) => {
          dispatch({
            type: ADD_TO_FAVORITES,
            item: pProduct
          })
        });
    } else {
      dispatch(openModal());
    }
  }
};


export function removeFromFavorite(pProductId) {
  return (dispatch, getState) => {
    let { user } = getState();
    let pid=user.data.user_id

    if (user.authenticated) {
      return axios
        .delete(FAVORITES_API_URL, {
          params: { product_id: pProductId, user_id: pid },
          headers: {
            'Authorization': `Bearer ${user.data.token}`
          }
        })
        .then(() => {
          dispatch({
            type: REMOVE_FROM_FAVORITES,
            item: pProductId
          })
        })
    } else {
      dispatch(openModal());
    }
  }
};

export function getFavorites() {
  return async (dispatch, getState) => {
    const { user } = getState();
    const pid = user.data.user_id;

    if (!user.authenticated) {
      dispatch(openModal());
      return;
    }

    dispatch({ type: FETCH_FAVORITES });

    try {
      console.log(`${FAVORITES_API_URL}?per_page=100`);

      const firstRes = await axios.get(`${FAVORITES_API_URL}?per_page=100`, {
        params: { user_id: pid },
        headers: {
          'Authorization': `Bearer ${user.data.token}`
        }
      });

      let totalPages = parseInt(firstRes.headers['x-wp-totalpages'] || 1, 10);
      let allItems = [...firstRes.data];

      console.log('x');
      console.log(firstRes.data);
      console.log('x2');

      for (let currentPage = 2; currentPage <= totalPages; currentPage++) {
        const res = await axios.get(`${FAVORITES_API_URL}?per_page=100&page=${currentPage}`, {
          headers: {
            'Authorization': `Bearer ${user.data.token}`
          }
        });
        allItems = [...allItems, ...res.data];
      }

      dispatch({
        type: RECEIVE_FAVORITES,
        items: allItems
      });

    } catch (err) {
      console.error('Failed to load my favorites', err);
      dispatch({ type: RECEIVE_FAVORITES });
    }
  };
}



export function getFavoritesOther() {
  return async (dispatch, getState) => {
    const { user } = getState();

    if (!user.authenticated) {
      dispatch(openModal());
      return;
    }

    // Use your canonical domain (no 'www')
    const canonicalUrl = 'https://voilacatalog.com/favorites';
    const currentUrl = window.location.href;
    const uidFromUrl = currentUrl.replace(`${canonicalUrl}?list=`, '');
    const userId = uidFromUrl;

    // If not a valid user ID, bail early
    if (!userId || userId === canonicalUrl || userId === 'https://www.voilacatalog.com/') {
      return;
    }

    // Indicate we are starting to fetch
    dispatch({ type: FETCH_FAVORITES_OTHER });

    try {
      // 1. Get the other user's name
      const userRes = await axios.get(`${VoilaConfig.API_URL}/wp/v2/users/${userId}`, {
        headers: {
          'Authorization': `Bearer ${user.data.token}`
        }
      });
      const uname = userRes.data.name;

      // 2. Get first page of favorites for that user
      const firstRes = await axios.get(`${FAVORITES_API_URL}?per_page=100`, {
        params: { user_id: userId },
        headers: {
          'Authorization': `Bearer ${user.data.token}`
        }
      });

      const totalPages = parseInt(firstRes.headers['x-wp-totalpages'] || 1, 10);
      let allItems = [...firstRes.data];

      // 3. Paginate through remaining pages
      for (let page = 2; page <= totalPages; page++) {
        const res = await axios.get(`${FAVORITES_API_URL}?per_page=100&page=${page}`, {
          headers: {
            'Authorization': `Bearer ${user.data.token}`
          }
        });
        allItems = [...allItems, ...res.data];
      }

      // 4. Dispatch ONCE with the full list
      dispatch({
        type: RECEIVE_FAVORITES_OTHER,
        items: allItems,
        uname: uname
      });

    } catch (err) {
      console.error('Failed to load other user favorites', err);
      // Still flip isFetching off, even on error
      dispatch({ type: RECEIVE_FAVORITES_OTHER });
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/FavoritesActions.js